import { useEffect, useRef } from 'react';
import type React from 'react';

interface MenuDropdownProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  onClickOutside?: (e?: MouseEvent) => void;
}

const MenuDropdown = ({ children, className, onClickOutside, ...props }: MenuDropdownProps) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!onClickOutside) return;

    const handleMouseDown = (e: MouseEvent) => {
      const dropdownEl = dropdownRef.current;
      if (!dropdownEl) return;

      if (e.target instanceof Node && dropdownEl.contains(e.target)) return;
      onClickOutside();
    };

    document.addEventListener('mousedown', handleMouseDown);
    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, [onClickOutside]);

  return (
    <div
      ref={dropdownRef}
      className={`flex flex-col rounded-[12px] bg-background-elevated shadow-[0_0_10px_0_rgba(0,0,0,0.04)] py-[12px] ${className ?? ''}`}
      {...props}
    >
      {children}
    </div>
  );
};

interface MenuDropdownItemProps extends React.HTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  isActive?: boolean;
}

const MenuDropdownItem = ({ children, className, isActive, ...props }: MenuDropdownItemProps) => {
  return (
    <button
      className={`px-[24px] py-[8px] text-[14px] h-[33px] text-center text-nowrap ${isActive ? 'text-text-main-lv1 font-semibold' : 'text-text-main-lv4 font-medium'} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export { MenuDropdown, MenuDropdownItem };
